import { render, staticRenderFns } from "./entrepreneurship.vue?vue&type=template&id=0e5b918c&scoped=true&"
import script from "./entrepreneurship.vue?vue&type=script&lang=js&"
export * from "./entrepreneurship.vue?vue&type=script&lang=js&"
import style0 from "./entrepreneurship.vue?vue&type=style&index=0&id=0e5b918c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5b918c",
  null
  
)

export default component.exports